var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normalModule"},[_c('emptyModule',[_c('div',{staticClass:"bar"},[_c('span'),_c('span')]),_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('section',[_vm._t("main")],2),_c('footer',[_vm._t("footer")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }